import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

function emptyDashboard() {
  return {
    kpis: {
      branchesTotal: 0,
      branchesActive: 0,
      boardMembersTotal: 0,
      boardMembersActive: 0,
      shareholdersTotal: 0,
      decisionsTotal: 0,
      decisionsPending: 0,
      decisionsApproved: 0,
      decisionsRejected: 0,
    },
    decisionsDistribution: [0, 0, 0],
    votesTrend: { categories: [], approve: [], reject: [], abstain: [] },
    branchesBoard: { categories: [], values: [] },
    shareholderTypes: { labels: [], series: [] },
    recentDecisions: [],
  };
}

export async function fetchSecretaryDashboard() {
  const res = await fetch(`${API_BASE}/api/secretary/dashboard`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل لوحة التحكم'));
  return { ...emptyDashboard(), ...data };
}

export async function fetchSuperAdminDashboard() {
  const res = await fetch(`${API_BASE}/api/superadmin/dashboard`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل لوحة تحكم السوبر أدمن'));
  return { ...emptyDashboard(), ...data };
}
